import React from "react";
import GallerySlider from "components/GallerySlider/GallerySlider";
import { BookingStatus, canSeeContact } from "../bookingStatus";

interface Props {
  booking: any;
  status: BookingStatus;
  shared: boolean;
}

/** Property photos, name and location. The full address only appears once confirmed. */
const PropertyCard: React.FC<Props> = ({ booking, status, shared }) => {
  const p = booking?.property || {};
  const roomIds: string[] = (booking?.line_items || []).map((i: any) => i.room_id);
  const href = shared
    ? `/listing-stay-detail/${p.slug}?room=${roomIds.join(",")}`
    : `/listing-stay-detail/${p.slug}`;

  const approxLocation = [p.neighborhood, p.city, p.state].filter(Boolean).join(", ");
  const location = canSeeContact(status) ? p.address || approxLocation : approxLocation;

  return (
    <section
      aria-label="Property"
      className="overflow-hidden rounded-2xl border border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-900"
    >
      <div className="relative">
        <GallerySlider
          uniqueID={`PropertyCard_${booking?.id}`}
          ratioClass="aspect-w-4 aspect-h-3"
          galleryImgs={p.place_images || []}
          href={href}
        />
        <span className="absolute left-3 top-3 z-[1] rounded-lg bg-black/70 px-3 py-1.5 text-xs font-semibold text-white">
          {shared ? "Shared property" : "Entire property"}
        </span>
      </div>
      <div className="space-y-2 p-5">
        <h3 className="text-lg font-semibold leading-tight text-neutral-900 dark:text-white">{p.title}</h3>
        {location && <p className="text-sm text-neutral-600 dark:text-neutral-300">{location}</p>}
        {!canSeeContact(status) && (
          <p className="text-xs text-neutral-500 dark:text-neutral-400">The full address is shared once your booking is confirmed.</p>
        )}
        {shared && booking?.booked_room && (
          <p className="text-sm text-neutral-800 dark:text-neutral-200">
            <span className="text-neutral-500 dark:text-neutral-400">Room: </span>
            <span className="font-medium">{booking.booked_room}</span>
          </p>
        )}
        {p.slug && (
          <a href={href} className="inline-flex min-h-[44px] items-center text-sm font-medium text-[#C2410C] dark:text-[#FF8A6E] hover:underline">
            View listing
          </a>
        )}
      </div>
    </section>
  );
};

export default PropertyCard;
